




















import GiftChoiceDropdown from './gift-choice-dropdown'
import GiftChoiceSelector from './gift-choice-selector'
export default
	components: {
		GiftChoiceDropdown
		GiftChoiceSelector
	}

	computed:

		# Helpers to make template easeir to read
		enabled: -> @getter 'enabled'
		isEligible: -> @getter 'isEligible'
		remainingSpend: -> @getter 'remainingSpend'
		products: -> @getter 'products'

	methods:

		# Helper for accessing the right getter
		getter: (property) -> @$store.getters["free-gift/choice/#{property}"]

